import React, {useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Transfer, Button } from 'antd';
import { Select } from 'antd';
import moment from 'moment';
import 'moment/locale/es';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import Loading  from '../../../img/loading.svg';

const { Option } = Select;

const ModalDuplicarViaje = (props) => {
    const [mockData,setMockData] = useState([]);//Viajes en el transfer
    const [targetKeys,setTargetKeys] = useState([]);//Meses en el transfer
    const [viajesSeleccionados,setViajesSeleccionados] = useState([]);// Viajes que se seleccionan en el transfer
    const [mesesSeleccionados,setMesesSeleccionados] = useState([]);//Meses que se seleccionan en el transfer
    const [viajesAplicables,setViajesAplicables] = useState([]);//Viajes que aplican para duplicar
    const [fechasHabilitadas,setFechasHabilitadas] = useState([]);//Meses en los que se puede duplicar el viaje
    const [valor,setValor] = useState("todos");
    const [isChanging, setIsChanging] = useState(false);

    const eventos = props.eventos;//Viajes del mes
    const meses = [
        "Enero", "Febrero", "Marzo",
        "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre",
        "Octubre", "Noviembre", "Diciembre"
    ];
    const refCargando = useRef(null);
    const refGuardar = useRef(null);

    useEffect(()=>{
        getMock();
    },[]);

    //Para filtrar
    useEffect(()=>{
        getMock();
        setMockData([]);
        setTargetKeys([]);
        setViajesAplicables([]);
        setMesesSeleccionados([]);
        setViajesAplicables([]);
        setFechasHabilitadas([]);
        setIsChanging(false);
    },[valor]);

    //Obtener los viajes del mes
    const getTravelsOfMonth=(viajes,fecha)=>{
        const anio = new Date(fecha).getFullYear();
        const mes = new Date(fecha).getMonth();
        let travels = [];
        for(let viaje of viajes){
            const monthStart = new Date(viaje.start).getMonth();
            const yearStart = new Date(viaje.start).getFullYear();
            if(monthStart===mes && yearStart===anio){
                const repetido = avoidRepeat(travels,viaje);
                if(!repetido){
                    travels.push(viaje);
                }
            }
        }
        return travels;
    }

    const avoidRepeat=(travels,viaje)=>{
        let repetido = false;
        for(let travel of travels){
            if(travel.id===viaje.id){
                repetido = true;
            }
        }
        return repetido;
    }

    const getTipo=(viajes)=>{
        if(valor!=="todos"){
            let travels = [];
            for(let viaje of viajes){
                const tipo = viaje.desc;
                if(tipo===valor){
                    travels.push(viaje);
                }
            }
            return travels;
        }else{
            return viajes;
        }
    }

    const getStart=async(eventosMes)=>{
        //id, start, end, title, desc
        let aux = [];
        let viajesApl = [];

        if(eventosMes.length>0){
            eventosMes.map((obj)=>{
                const fechaObj = new Date(obj.start).toDateString();
                aux.push(obj.title);
                let objA = {
                    id: obj.id,
                    start: obj.start,
                    end: obj.end,
                    title: obj.title,
                    desc: obj.desc
                };
                viajesApl.push(objA);
            });
            return [aux,viajesApl];
        }
    }

    const getFormattedDate=()=>{    
        const dateObj = new Date(props.fechaEnPantalla);
        let mes = dateObj.getMonth();
        let anio = dateObj.getFullYear();
        return meses[mes] + "/" + anio;
    }
    
    const getMock=async()=> {
        const fechasH = await getNextSixMonths();
        const mesesEnabled = fechasH[0];
        let viajesDelMes = getTravelsOfMonth(eventos,props.fechaEnPantalla);
        viajesDelMes = getTipo(viajesDelMes);//Obtener segun tipo
        const dataDelMes = await getStart(viajesDelMes);
        const targetKeysA = [];
        const mockDataA = [];
        if(viajesDelMes.length>0){
            const dataAux = meses.concat(dataDelMes[0]);
            const lMeses = meses.length;

            for (let i = 0; i < dataAux.length; i++) {
                const isChosen = i < lMeses ? true : false;
                let isEnabled = false;
                if(i<lMeses){
                    isEnabled = true;
                    for(let j=0; j < mesesEnabled.length; j++){
                        if(mesesEnabled[j]===i){
                            isEnabled = false;
                        }
                    }
                }
                // console.log('dataDelMes[1][i] :', dataDelMes[1][i]);
                const data = {
                key: i.toString(),
                title: ``,
                description: `${dataAux[i]}`,
                chosen: isChosen,
                disabled: isEnabled,
                };
                if (data.chosen) {
                targetKeysA.push(data.key);
                }
                mockDataA.push(data);
            }
            setMockData(mockDataA);
            setTargetKeys(targetKeysA);
            setViajesAplicables(dataDelMes[1]);
            setFechasHabilitadas(fechasH[1]);
        }
    }

    const handleChange = (targetKeys) => {
        setTargetKeys(targetKeys);
    };

    const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        setViajesSeleccionados(sourceSelectedKeys);
        setMesesSeleccionados(targetSelectedKeys);
    };

    const getNextSixMonths = () =>{
        const mesInicio = new Date(props.fechaEnPantalla).getMonth();
        const anio = new Date( props.fechaEnPantalla ).getFullYear();
        let mesesEnabled = [];
        let fechasH = [];
        let index = mesInicio + 1;//+1 porque inicia a partir del siguiente mes
        while(mesesEnabled.length<6){
            if(index>11){
                mesesEnabled.push(index-12);
                fechasH.push([index-12,anio+1]);
            }else{
                mesesEnabled.push(index);
                fechasH.push([index,anio])
            }
            index++;
        }
        return [mesesEnabled,fechasH];
    }

    //Guardar
    const printSelected = async(e) => {
        //guardar_datos
        //const boton = e.target;
        if(viajesSeleccionados.length>0 && mesesSeleccionados.length>0){
            refGuardar.current.style.display = 'none';
            refCargando.current.style.display = 'inline-block';
            let cantidadGuardados = 0;
            let mostrarProcesando = true;
            for(const viaje of viajesSeleccionados){
                const viajeAplicable = viajesAplicables[viaje-12];
                const key = viajeAplicable.id;
                let frecuencia = [];
                let prograsDiakey = [];

                //Obtener referencia del viaje en firebase
                const refProgra = firebase.database().ref('Programacion').child(key);
                const snapProgra = await refProgra.once('value');
                const dataProgra = snapProgra.val();
                const fechasBaneadas = getMonthsAdded(dataProgra);

                if(mostrarProcesando){
                    Alert.info('Procesando la información, por favor espere.', {
                        position: 'bottom-right',
                        timeout: 6000
                    });
                    mostrarProcesando = false;
                }   

                for (const mes of mesesSeleccionados) {
                    const {frecuencias, prograsDiakeys} = await rellenarMes(mes, dataProgra,key,fechasBaneadas);
                    frecuencia = frecuencia.concat(frecuencias);
                    prograsDiakey = prograsDiakey.concat(prograsDiakeys);
                }

                if(frecuencia.length>0 && prograsDiakey.length>0){
                    await refProgra.update({
                        frecuencia: [...dataProgra.frecuencia, ...frecuencia],
                        programacionDia: [...dataProgra.programacionDia, ...prograsDiakey]
                    });
                    cantidadGuardados+= frecuencia.length;
                }else{
                    // console.log('La programacion ya habia sido duplicada en los meses seleccionados');
                }       
            }
            if(cantidadGuardados>0){
                Alert.closeAll();
                Alert.success('Datos guardados exitosamente.', {
                    position: 'bottom-right',
                    timeout: 3000
                });
                props.update();
                //props.close();
                //window.location.reload();
            }else{
                Alert.closeAll();
                Alert.error('Los meses seleccionados ya están programados.', {
                    position: 'bottom-right',
                    timeout: 3000
                });
                refCargando.current.style.display = 'none';
                refGuardar.current.style.display = 'inline-block';
            }
        }else{
            Alert.warning('Seleccione al menos un mes y una programación a duplicar.', {
                position: 'bottom-right',
                timeout: 3000
            });
        }
    }

    const rellenarMes = async  (mes, programacion,key,fechasBaneadas)=>{
        const datosFecha = getNumOfDays(mes);//[0]= num_dias, [1]=mes, [2]= anio
        const isDuplicating = isMonthDuplicating(fechasBaneadas,datosFecha[1],datosFecha[2]);
        let frecuencias = [];
        let prograsDiakeys = [];
        const prograDia =  await optimizardata(programacion,key);
        const fechaPrograDia =  new Date(getFechaPrograDia(datosFecha[1],datosFecha[2]));

        if(!isDuplicating){
            for(let i=0; i<datosFecha[0]; i++){
                fechaPrograDia.setDate(i+1);
                prograsDiakeys.push(await insertarPrograDia(prograDia,fechaPrograDia,frecuencias));
            }
        }else{
            // console.log('La programacion ya esta duplicada en el mes de: '+ meses[parseInt(datosFecha[1])-1] + 
            // ' del anio: ' + datosFecha[2]);
        }
        
        return { frecuencias, prograsDiakeys}
    }

    const isMonthDuplicating=(fechasBaneadas,mes,anio)=>{
        let isDuplicating = false;
        fechasBaneadas.map((fechaBaneada)=>{
            const mesB = fechaBaneada.mes + 1;
            const anioB = fechaBaneada.anio;
            if(mesB===parseInt(mes) && anioB===parseInt(anio))
                isDuplicating = true;
        });
        return isDuplicating;
    }

    const insertarPrograDia=async(programacion,fecha,frecuencias)=>{
        const obj = JSON.parse(JSON.stringify(programacion));
        obj.fecha = fecha+"";
        const insercion = await firebase.database().ref('ProgramacionDia').push(obj);
        await frecuencias.push(obj.fecha);
        return insercion.key;
    }

    const optimizardata=async(data,key)=>{
        let pD = {
            estado: 'Pendiente',
            horaInicio: data.horaReco,
            horaLlegada: data.horaAero,
            programacion: key,
            puntoA: 0,
            vehiculo: "",
            conductor: "",
            ruta: data.ruta,
        }
        let datos = {
            ...pD,
            centroC: data.centroC
        };
        datos = await props.optimizarPrograDia(datos);
        return datos;
    }

    const getNumOfDays=(mes)=>{
        for(let i=0; i<fechasHabilitadas.length; i++){
            if(mes==fechasHabilitadas[i][0]){
                let anio = fechasHabilitadas[i][1];
                let mes = (parseInt(fechasHabilitadas[i][0])+1) < 10 ? '0' : '';
                mes += (parseInt(fechasHabilitadas[i][0])+1)
                const formato = anio + "-" + mes;
                const num_dias = moment(formato).daysInMonth();
                return [num_dias, mes, anio];
            }
        }
    }

    const getFechaPrograDia=(mes,anio)=>{
        let fecha = new Date();
        fecha.setMonth(mes-1);
        fecha.setFullYear(anio);
        fecha.setHours(0);
        fecha.setMinutes(0);
        fecha.setSeconds(0);
        return fecha;
    }

    const getMonthsAdded=(programacion)=>{
        const fechas = programacion.frecuencia;
        let datesAdded = [];
        let band = 0;
        fechas.map((fecha)=>{
            const mes = new Date(fecha).getMonth();
            const anio = new Date(fecha).getFullYear();
            band = 0;
            datesAdded.map((dateA)=>{
                if(mes===dateA.mes && anio===dateA.anio)
                    band = 1;
            });
            if(band===0){
                const obj = {
                    mes: mes,
                    anio: anio
                }
                datesAdded.push(obj);
            }
        });
        return datesAdded;
    }

    const handleChangeSelect=(evento)=>{
        const val = evento.target.value;
        setValor(val);
        setIsChanging(true);
    }

    // const renderFooter = () => (
    //     <Button size="small" style={{ float: 'right', margin: 5 }} onClick={()=>getMock()}>
    //       reload
    //     </Button>
    // );

    return (
    <Wrapper >
        <div className='modalDuplicarViaje'>
			<div className="right-container">
				<div onClick={()=>props.close()} className="close">
					<label className="close-text">X</label>
				</div>
			</div>
            <div className='margin-container'>
                <div>
                    <label className="lbl">{getFormattedDate()}</label>
                </div>
                <div>
                    <label className="lbl">Duplicar viaje</label>
                </div>
            </div>
            <div className='margin-container'>
            <select style={{ width: '51%' }}  name="tipo" className="form-control" onChange={(e)=>handleChangeSelect(e)} value={valor}>
                <option value="todos">Todos</option>
                <option value="pilotos"> Pilotos en Operación</option>
                <option value="pilotossap">Pilotos en Academia</option>
                <option value="tcs"> Tripulantes de Cabina en Operación</option>
                <option value="tcssap">Tripulantes de Cabina en Academia</option>
                <option value="persTierr">Personal Tierra en Operación</option>
            </select>
            </div>
            <div className='transfer-container'>
                {
                    !isChanging?
                    <StyledTransfer
                        titles={['Viajes', 'Meses']}
                        style={{ marginTop: '20px', marginBottom: '20px' }}
                        dataSource={mockData}
                        showSearch
                        listStyle={{
                        width: 250,
                        height: 300,
                        }}
                        locale={ {itemUnit: 'elemento', itemsUnit: 'elementos', notFoundContent: 'No hay elementos para duplicar', searchPlaceholder: 'Buscar'} }
                        // operations={['to right', 'to left']}
                        onSelectChange = { handleSelectChange }
                        targetKeys = { targetKeys }
                        onChange = { handleChange }
                        render = {item => `${item.title}-${item.description}`}
                        //footer = { renderFooter }
                    />
                    :
                    null
                }
            </div>
            <div className='transfer-container'>
                <img style={{ display: 'none', width: '9%', heigth: '9%' }} ref={refCargando} src={Loading} />
                <button style={{display: 'inline-block'}} onClick={(e)=>printSelected(e)} ref={refGuardar} id="guardar_datos" className="btn btn-round color1 margin-item">Guardar</button>
            </div>
        </div>
        <div className='background' onClick={()=>props.close()} /> 
    </Wrapper>
    );
}

const StyledTransfer = styled(Transfer)`

	.ant-transfer-operation{
        display: none;
    }

	.ant-transfer-list:nth-child(1){
		width: 350px !important;
		height: 300px;
		margin-right: 15px !important;
	}

	@media (max-width: 1030px) {
		.ant-transfer-list{
			width: 100% !important;
			margin-top: 10px !important;
		}
		.ant-transfer-list:nth-child(1){
			margin-right: 0px !important;
		}
	}
`

const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    position: fixed;
    background: rgba(0,0,0,0.2);
    width:100vw;
    height:100vh;
    top:0;
    left: 0;
    z-index: 25;

    .transfer-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modalDuplicarViaje{
        background: white;
        width:60vw;
        /* min-width: 789px; */
        /* height:60vh; */
        /* min-height: 476px; */
        border-radius: 10px;
        border: 1px solid #C4C4C4;
        z-index:26;
		display: flex;
		flex-direction: column;
    }

	.right-container{
		display: flex;
		justify-content: flex-end;
		height: 40px;
		align-items: center;
	}

	.close{
		display: flex;
		justify-content: center;
		align-items: flex-end;
		height: 30px;
  		width: 30px;
		background-color: black;
  		border-radius: 50%;
		margin-right: 10px;
	}
	
	.close-text{
		color: white;
		font-size: 12px;
		font-weight: bold;
		font-family: Avenir;
	}

    .background{
        position:absolute;
        width:100%;
        height:100%;
    }

    .lbl{
        font-family: Avenir;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #000000;
    }

    .margin-container{
        margin-top: 15px;
        display: flex;
        justify-content: space-evenly;
    }

    .margin-item{
        margin-top: 2%;
        margin-bottom: 2%;
    }

	@media (max-width: 1030px) {
		.ant-transfer{
			display: flex;
			flex-direction: column;
		}

		.modalDuplicarViaje{
			height: 100vh;
			overflow-y: scroll;
		}
	}

	@media (max-width: 625px) {
		.modalDuplicarViaje{
			width: 90vh;
			overflow-y: scroll;
		}
	}

`

export default ModalDuplicarViaje;


// WEBPACK FOOTER //
// ./src/Components/Rutas/Components/ModalDuplicarViaje.js